import React from 'react';
import { useFilters } from '../../hooks/useFilters';
import { WeatherDependence } from '../Common/WeatherDependence';
import { CostRange } from '../Common/CostRange';
import { DurationRange } from '../Common/DurationRange';

const PropertiesFilter = () => {
  const { filters, updateFilter } = useFilters();

  return (
    <div className="properties-filter">
      <WeatherDependence
        value={filters.indoor_outdoor}
        onChange={(v) => updateFilter('indoor_outdoor', v)}
        showAll
      />

      <CostRange
        value={filters.cost_range}
        onChange={(v) => updateFilter('cost_range', v)}
        showAll
      />

      <DurationRange
        value={filters.duration}
        onChange={(v) => updateFilter('duration', v)}
        showAll
      />
    </div>
  );
};

export default PropertiesFilter;
